









import Vue from 'vue';

export default Vue.extend({
    name: 'EnumSelector',
    props: {
        enumObject: {
            required: true,
            type: Object,
        },
        css: {
            required: false,
            type: String
        },
        value: {
            type: Number
        },
        placeholder: {
            type: String,
            required: false,
        },
    },
    computed: {
        enumValues() {
            return Object.keys(this.enumObject)
                .filter(k => typeof this.enumObject[k as any] === 'string');
        }
    },
    data() {
        return {
            i18nPrefix: 'shared.enumSelector',
            selected: this.value
        };
    },
    watch: {
        selected(selected: string) {
            this.$emit('input', selected);
        },
        value(newValue) {
            this.selected = newValue;
        }
    }
});
